import { AvisoSetor, AvisoStorage, Orgao, Usuario } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';

export class Aviso extends BaseResourceModel {
  constructor(
    public id?: number,
    public mensagem?: string,
    public data_inicio?: Date,
    public data_fim?: Date,
    public emissor?: Usuario,
    public orgao?: Orgao,
    public setores?: AvisoSetor[],
    public storages?: AvisoStorage[]
  ) {
    super();
  }

  static converteJson(json: any): Aviso {
    return Object.assign(new Aviso(), json);
  }
}
